/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import styles from '../../../../static/scss/components/footer.module.scss';

const SocialLinks = () => (
  <ul className={styles.unstyledList}>
    <li className={styles.socialListItem}>
      <a
        href="https://www.facebook.com/JustParkHQ/"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-facebook"
        aria-label="facebook"
      />
    </li>

    <li className={styles.socialListItem}>
      <a
        href="https://www.instagram.com/justparkhq/"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-instagram"
        aria-label="Instagram"
      />
    </li>

    <li className={styles.socialListItem}>
      <a
        href="https://twitter.com/JustPark"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-twitter"
        aria-label="twitter"
      />
    </li>

    <li className={styles.socialListItem}>
      <a
        href="https://www.linkedin.com/company/justpark"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-linkedin2"
        aria-label="LinkedIn"
      />
    </li>
  </ul>
);

export default SocialLinks;
